export default __webpack_public_path__ + "static/media/p9.09ba228e.png";